import { Payment } from '../types';

const BASE_CURRENCY = 'EUR';

/**
 * Amount to use on revenue charts / summaries (user base currency).
 * EUR payments store amount_base_currency as NULL in DB and may briefly be 0
 * in optimistic mark-as-paid updates — always fall back to `amount`.
 */
export function getRevenueAmount(payment: Payment): number {
  const currency = payment.currency || BASE_CURRENCY;
  if (currency === BASE_CURRENCY) {
    return Number(payment.amount) || 0;
  }
  if (payment.amountBaseCurrency != null && Number(payment.amountBaseCurrency) !== 0) {
    return Number(payment.amountBaseCurrency);
  }
  return Number(payment.amount) || 0;
}

export function revenueAmountForMarkAsPaid(payment: Payment, amountBaseCurrency: number): number {
  const currency = payment.currency || BASE_CURRENCY;
  if (currency === BASE_CURRENCY) {
    return payment.amountBaseCurrency != null && Number(payment.amountBaseCurrency) !== 0
      ? Number(payment.amountBaseCurrency)
      : Number(payment.amount) || 0;
  }
  return Number(amountBaseCurrency) || 0;
}
